import { render, staticRenderFns } from "./AsiDialogForm.vue?vue&type=template&id=127cf146&scoped=true"
import script from "./AsiDialogForm.vue?vue&type=script&lang=ts"
export * from "./AsiDialogForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127cf146",
  null
  
)

export default component.exports